﻿/**
 * Checks if the purchase order ID is valid by checking that it is a string, contains only digits, and is exactly 7 digits long.
 */
export function purchaseOrderIdIsValid(purchaseOrderId: string): boolean {
    return typeof purchaseOrderId === "string" && /^[0-9]*$/i.test(purchaseOrderId) && purchaseOrderId.length === 7;
}
